import controller_0 from '@symfony/ux-turbo/dist/turbo_controller.js';
import '@symfony/ux-turbo/dist/mercure_stream_source_element.js';
export default {
  'symfony--ux-turbo--turbo-core': controller_0,
};